const projectsEnglish = {
    bidders: "BIDDERS",
    totalBidders: "TOTAL BIDDERS",
    projectStatus: "PROJECT STATUS",
    searchPlaceholder: "Type a project title to search ...",
    data: "Data",
    feedback: "Feedback",
    monitoring: "Progress",
    progress: "Progress",
    previous: "previous",
    next: "next",
    social: "Social",
    infrastructure: "Infrastructure",
    all: "All",
    filters: {
        title: "FILTERS",
        budgetRange: "ALLOCATED BUDGET RANGE",
        search: "SEARCH",
        allWards: "ALL WARDS",
        type: "PROCUREMENT TYPE",
        department: "DEPARTMENT",
        projectType: "Project Type",
        budgetProgramType: "BUDGET PROGRAM TYPE",
        budgetProgramSubType: "BUDGET PROGRAM SUB-TYPE",
    },
    projectTable: {
        title: "PROJECT TITLE",
        contractBudget: "ALLOCATED BUDGET (NRS.)",
        estimatedBudget: "ESTIMATED BUDGET (NRS.)",
        all: "All",
        contractor: "Contractor",
        userCommittee: "User Committee",
        contractingParty: "CONTRACTING PARTY",
        quotationWork: "Quotation Work",
        department: "DEPARTMENT",
        wards: "WARDS",
        status: "STATUS",
        tendered: "Tendered",
        typeOfProject: "Type of project",
    },
    departments: {
        "health": "Health",
        "education": "Education",
        "agriculture": "Agriculture",
        "veterinary": "Veterinary",
        "women_development": "Women development",
        "social_development": "Social development",
        "disaster_management": "Disaster management",
        "cooperative": "Cooperative",
        "infrastructure": "Infrastructure",
        "store": "Store",
    },
    procurementTypes: {
        "user_committee": "User Committee",
        "tendered": "Tendered",
        "quotation_work": "Quotation Work",
        // "private_company": "Private Company",
        "municipality": "Municipality",
        "rural_municipality": "Rural Municipality",
        "custom": "Custom",
    },
    projectTypes: {
        "infrastructure": "Infrastructure",
        "social": "Social"
    },
    project_budget_program: {
        national_government: 'National Government',
        province_government: 'Province Government',
        municipality: 'Municipality',
    },
    project_budget_program_type: {
        national_government: {
            national_conditional: 'National Conditional',
            national_supplement: 'National Supplement',
            national_special: 'National Special',
        },
        province_government: {
            province_conditional: 'Province Conditional',
            province_supplement: 'Province Supplement',
            province_special: 'Province Special',
        },
        municipality: {
            municipality_municipality: 'Municipality',
            ward: 'Ward',
            disaster_management_fund: 'Disaster Management Fund',
            maintenance_fund: 'Maintenance Fund',
            partnership_program: 'Partnership Program (Cost Sharing 60/40)',
            miscellaneous_public_construction: 'Miscellaneous Public Construction',
            carried_forward: 'Carried Forward',
            irrigation_canal: 'Irrigation canal construction and labor maintenance partnership 75/25',
            crusher_affected: 'Crusher Affected Area Development Program',
        },
    }
}

const projectsNepali = {
    bidders: "बोलपत्रहरूदाताहरु",
    totalBidders: "कुल बोलपत्रहरूदाताहरु",
    projectStatus: "परियोजनाकाे अवस्था",
    searchPlaceholder: "परियोजना खाेज्नुहाेस्",
    data: "तथ्यांक",
    feedback: "जन सुझाव",
    monitoring: "प्रगति अवस्था",
    progress: "प्रगति",
    previous: "अघिल्लो",
    next: "अर्को",
    all: "सबै",
    social: "सामाजिक",
    infrastructure: "पूर्वाधार",
    filters: {
        title: "फिल्टरहरू",
        budgetRange: "विनियोजित बजेटकाे सीमा",
        search: "खोज्नुहोस्",
        allWards: "सबै वडाहरू",
        type: "परियोजनाको खरीद प्रकार",
        department: "विभाग",
        projectType: "परियोजनाको प्रकार",
        budgetProgramType: "बजेट कार्यक्रमको प्रकार",
        budgetProgramSubType: "बजेट कार्यक्रमको उप-प्रकार",
    },
    projectTable: {
        title: "परियोजनाकाे शीर्षक",
        contractBudget: "विनियोजित बजेट (रु.)",
        estimatedBudget: "अनुमानित लागत (रु.)",
        all: "सबै",
        contractor: "निर्माण व्यवसायी",
        department: "विभाग",
        userCommittee: "उपभाेक्ता समिति",
        contractingParty: "कन्ट्र्याक्टिंग पार्टी",
        quotationWork: "कोटेसन",
        wards: "वडाहरू",
        status: "अवस्था",
        tendered: "टेण्डर भएकाे",
        typeOfProject: "परियोजनाको प्रकार",
    },
    departments: {
        "health": "स्वास्थ्य",
        "education": "शिक्षा",
        "agriculture": "कृषि",
        "veterinary": "पशु स्वास्थ्य",
        "women_development": "महिला विकास",
        "social_development": "सामुदायिक विकास",
        "disaster_management": "विपद व्यवस्थापन",
        "cooperative": "सहकारी",
        "infrastructure": "पूर्वाधार",
        "store": "स्टोर",
    },
    procurementTypes: {
        "user_committee": "उपभाेक्ता समिति",
        "tendered": "टेन्डर",
        "quotation_work": "उद्धरण कार्य",
        // "private_company": "निजी कम्पनी",
        "municipality": "नगरपालिका",
        "rural_municipality": "गाँउपालिका",
        "custom": "Custom",
    },
    projectTypes: {
        "infrastructure": "पूर्वाधार",
        "social": "सामाजिक"
    },
    project_budget_program: {
        national_government: 'संघीय सरकार',
        province_government: 'प्रदेश सशर्त',
        municipality: 'नगरपालिका',
    },
    project_budget_program_type: {
        national_government: {
            national_conditional: 'संघीय सशर्त',
            national_supplement: 'संघीय समपूरक',
            national_special: 'संघीय विशेष',
        },
        province_government: {
            province_conditional: 'प्रदेश सशर्त',
            province_supplement: 'प्रदेश समपूरक',
            province_special: 'प्रदेश विशेष',
        },
        municipality: {
            municipality_municipality: 'नगरतर्फ',
            ward: 'वडा',
            disaster_management_fund: 'विपद व्‍यवस्थापन कोष',
            maintenance_fund: 'मर्मत सम्भार कोष',
            partnership_program: 'साझेदारी कार्यक्रम (लागत साझेदारी ६०/४०)',
            miscellaneous_public_construction: 'विविध सार्वजनिक निर्माण',
            carried_forward: 'अ.ल्या.',
            irrigation_canal: 'सिँचाइ कुलो निर्माण तथा मर्मत श्रम साझेदारी ७५/२५',
            crusher_affected: 'क्रशर प्रभावित क्षेत्र विकास कार्यक्रम',
        },
    }
}

export {
    projectsEnglish,
    projectsNepali,
}



// WEBPACK FOOTER //
// ./src/localization/projects.js